const routeConfig = [
	{ path: '/home', name:'Home', component: 'home' },
	{ path: '/transportauftrag/...', name:'Transportauftrag', component: 'transportauftrag', useAsDefault: true }

];

export default routeConfig;
